module.exports = __webpack_public_path__ + "static/media/placeholder3.751996d5.png";